import { render, staticRenderFns } from "./VerificationFormModal.vue?vue&type=template&id=77669bd2"
import script from "./VerificationFormModal.vue?vue&type=script&lang=js"
export * from "./VerificationFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports